module.exports = __webpack_public_path__ + "img/祥云_上@2x.70716e73.png";